import { forwardRef } from "react";
import { TestMenuItem, TestMenuItemTypo, TestStyledSelect } from "./Select.ui";

interface WithSelectProps {
  value: string;
  defaultValue: string;
  onChange: (value: string) => void;
  options: { label: string; value: string }[];
}

const withSelect = <P extends object>(
  Component: React.ComponentType<P>,
  MenuItemComponent: React.ComponentType<any>,
  WrapperComponent: React.ComponentType<any>,
) => {
  return forwardRef<any, React.PropsWithChildren<P & WithSelectProps>>(
    ({ value, defaultValue, onChange, options, ...props }, ref) => {
      return (
        <Component defaultValue={defaultValue} value={value} onChange={onChange} {...(props as P)}>
          {options.map((option) => (
            <MenuItemComponent key={option.value} value={option.value}>
              <WrapperComponent>{option.label}</WrapperComponent>
            </MenuItemComponent>
          ))}
        </Component>
      );
    },
  );
};

interface WithMenuItem {
  key: string;
  value: string;
  children: React.ReactNode;
}

const withMenuItem = <P extends object>(Component: React.ComponentType<P>) => {
  return forwardRef<any, React.PropsWithChildren<P & WithMenuItem>>(
    ({ key, value, children, ...props }, ref) => {
      return (
        <Component key={key} value={value} {...(props as P)} ref={ref}>
          {children}
        </Component>
      );
    },
  );
};

const TestSelectMenuItem = withMenuItem(TestMenuItem);
const TestSelect = withSelect(TestStyledSelect, TestSelectMenuItem, TestMenuItemTypo);

export { TestSelect };
